/** @jsx jsx */
import { merge } from 'lodash';
import { Colors } from '@zapier/theme';
import { jsx, Interpolation } from '@emotion/core';
import FacebookIcon from './FacebookIcon';
import SSOButton, { getStartUrlForProvider } from '../SSOButton';
import { defaultSSOButtonCSS } from '../../constants';

export type FacebookSSOButtonProps = {
  label?: string;
  href?: string;
  next?: string;
  onTrackSignupConversion?: (customUserId: string) => void | Promise<void>;
  onTrackSignupIntent?: () => void;
  passThrough?: boolean;
  shouldOpenInChildWindow?: boolean;
};

// The constants below are from Facebook Guidelines
const FACEBOOK_BLUE = '#3b5999';
const FACEBOOK_BOX_SHADOW =
  '0 0 1px rgba(#000, 0.12), 0 1px 1px rgba(#000, 0.24)';

const labelCss: Interpolation = {
  flex: 1,
  marginLeft: '-2rem', // compensate the logo to look like centered
  textAlign: 'center',
};

const defaultCss = merge(defaultSSOButtonCSS, {
  backgroundColor: FACEBOOK_BLUE,
  border: 'none',
  boxShadow: FACEBOOK_BOX_SHADOW,
  color: Colors.white,
  ':hover,:focus': {
    backgroundColor: FACEBOOK_BLUE,
    color: Colors.white,
  },
});

const href = getStartUrlForProvider('facebook');

const FacebookSSOButton: React.FC<FacebookSSOButtonProps> = ({
  label,
  ...props
}) => {
  return (
    <SSOButton href={href} {...props}>
      <span css={defaultCss}>
        <FacebookIcon />
        <span css={labelCss}>{label}</span>
      </span>
    </SSOButton>
  );
};

FacebookSSOButton.defaultProps = {
  label: 'Continue with Facebook',
};

export default FacebookSSOButton;
